export interface IRequestViewingViewModel {
    systemId: string;
    workingWithAgent: string;
    name: string;
    phone: string;
    email: string;
    request1Date: string;
    request1Time: string;
    request2Date: string;
    request2Time: string;
}

export class RequestViewingViewModel implements IRequestViewingViewModel {
    public systemId = '';
    public workingWithAgent = '';
    public name = '';
    public phone = '';
    public email = '';
    public request1Date = '';
    public request1Time = '';
    public request2Date = '';
    public request2Time = '';
    constructor(
        systemId: string,
        workingWithAgent: string,
        name: string,
        telephone: string,
        email: string,
        request1Date: string,
        request1Time: string,
        request2Date: string,
        request2Time: string,
    ) {
        this.systemId = systemId;
        this.workingWithAgent = workingWithAgent;
        this.name = name;
        this.phone = telephone;
        this.email = email;
        this.request1Date = request1Date;
        this.request1Time = request1Time;
        this.request2Date = request2Date;
        this.request2Time = request2Time;
    }
}
